import { render, staticRenderFns } from "./ApproveContactLetterPage.vue?vue&type=template&id=07548730&scoped=true&"
import script from "./ApproveContactLetterPage.vue?vue&type=script&lang=js&"
export * from "./ApproveContactLetterPage.vue?vue&type=script&lang=js&"
import style0 from "./ApproveContactLetterPage.vue?vue&type=style&index=0&id=07548730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07548730",
  null
  
)

export default component.exports